<template>
  <div class="mongo-instanceNode-page">
    <Card>
      <Row>
        <i-col span="24">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
      </Row>
      <Divider />
      <div>
        <tables ref="instanceNodeTable" height="600" v-model="nodeData"
                :columns="nodeColumns"/>
      </div>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getInstanceNode} from '@/api/mongodb'

export default {
  name: 'MongoDBInstanceNode',
  components: {
    Tables
  },
  data: function () {
    return {
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      nodeData: [],
      nodeColumns: [
        {title: '角色', key: 'role', align: 'center', minWidth: 100},
        {title: 'HOST', key: 'host', align: 'center', minWidth: 100},
        {title: 'PORT', key: 'port', align: 'center', minWidth: 100}
      ]
    }
  },

  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    getNode () {
      let params = {
        id: this.$route.query.id
      }
      this.inforCardData = this.infoTmpData
      getInstanceNode(params).then(res => {
        if (res.status === 200) {
          this.nodeData = res.data.results
        } else {
          this.$Notice.error({
            title: '获取统计信息失败'
          })
        }
      })
    },

    refresh () {
      this.getNode()
    }
  },

  mounted: function () {
    this.getNode()
  }
}
</script>
<style lang="less">
  .mongo-instanceNode-page{
    @media screen and (max-width:640px) {
      h1{
        font-size: 1.5em;
      }
      .ivu-table-wrapper,.ivu-table-body{
        height:auto!important;
      }
      .ivu-divider-horizontal{
          margin: 10px 0 15px;
      }
    }
  }
</style>
